import React, { useState, useEffect, useCallback, useRef } from 'react';
import { ThemeProvider } from '../../context';
import Navigation from '../../components/navigation';
import NavSpy from '../../components/nav-spy';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/scss/main.scss';

const Layout = ({ children }) => {
  const [height, setHeight] = useState(0);
  const [mobile, setMobile] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);

  const sections = useRef([
    'home',
    'about',
    'services',
    'portfolio',
    'team',
    'contact',
  ]);

  const sectionId = useRef(0);
  const scrolling = useRef(false);

  const updateDimensions = useCallback(() => {
    const windowWidth = window.innerWidth;

    setWidth(windowWidth);
    setHeight(windowWidth < 992 ? 'auto' : window.innerHeight);
    setMobile(windowWidth < 992);
  }, []);

  useEffect(() => {
    updateDimensions();

    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, [updateDimensions]);

  const changeSection = useCallback((id) => {
    sectionId.current = id;
  }, []);

  const wheel = useCallback(
    (e) => {
      if (mobile || scrolling.current) return;

      e.preventDefault();

      scrolling.current = true;

      let nextIndex = sectionId.current;

      if (e.deltaY > 0) {
        nextIndex = Math.min(
          sectionId.current + 1,
          sections.current.length - 1
        );
      } else {
        nextIndex = Math.max(sectionId.current - 1, 0);
      }

      if (nextIndex === sectionId.current) {
        scrolling.current = false;
        return;
      }

      sectionId.current = nextIndex;

      const element = document.getElementById(sections.current[nextIndex]);

      if (!element) {
        scrolling.current = false;
        return;
      }

      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      setTimeout(() => {
        scrolling.current = false;
      }, 900);
    },
    [mobile]
  );

  return (
    <ThemeProvider value={{ height: mobile ? 'auto' : height }}>
      <Navigation change={changeSection} />

      <div className='wrapper' onWheel={wheel}>
        {children}
      </div>

      <NavSpy change={changeSection} />
    </ThemeProvider>
  );
};

export default Layout;
